var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustandFaith(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 15453"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 70",
    cx: 11.1111,
    cy: 38.8885,
    r: 10.8333,
    stroke: "#FF2D20",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 71",
    cx: 36.1111,
    cy: 11.1111,
    r: 10.8333,
    stroke: "#0000FF",
    strokeWidth: 0.555556
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 72",
    cx: 22.2223,
    cy: 25.0001,
    r: 19.4444,
    fill: "#FF5555"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73",
    cx: 2.77778,
    cy: 5.55512,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 74",
    cx: 46.6667,
    cy: 38.8891,
    r: 2.77778,
    fill: "#FD5901",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.1227 15.4482C15.1227 15.4482 12.9764 20.7787 12.0033 28.7802C11.9162 29.4957 13.5637 28.8555 14.1322 28.6388C15.4168 20.758 17.2509 15.3579 17.2509 15.3579C16.7153 15.2661 15.1227 15.4482 15.1227 15.4482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.349 16.0326C25.1058 17.2587 24.775 19.2024 24.3168 21.1307C23.5608 24.2473 21.7781 27.4692 18.8935 27.4692C16.1662 27.4692 15.8826 24.5094 16.6082 21.4786C17.0489 19.642 17.7745 17.7683 18.8778 16.5247C19.7294 15.5768 20.896 15 22.0623 15C23.1971 15 23.9703 15.2268 24.349 16.0326ZM18.799 21.4971C18.1844 24.0383 18.4686 25.3155 19.4781 25.3155C20.5331 25.3155 21.5264 23.704 22.174 21.06C22.7725 18.538 22.4886 17.3805 21.4795 17.3805C20.5173 17.3805 19.462 18.782 18.799 21.4971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.5527 16.0336C33.3095 17.2587 32.9783 19.2024 32.5212 21.1303C31.7641 24.2469 29.9832 27.4696 27.098 27.4696C24.3706 27.4696 24.0863 24.5091 24.8119 21.4789C25.254 19.6417 25.9786 17.768 27.0826 16.5244C27.9338 15.5786 29.1001 15 30.2671 15C31.4025 15 32.1743 15.2268 32.5527 16.0336ZM27.0034 21.4975C26.3888 24.038 26.6723 25.3159 27.6811 25.3159C28.7382 25.3159 29.7312 23.7033 30.377 21.061C30.9759 18.537 30.6927 17.3802 29.6832 17.3802C28.7217 17.3805 27.665 18.782 27.0034 21.4975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.9479 31.3045C26.07 31.3045 16.2777 32.0749 12.4208 32.3921C12.158 31.3931 12.5013 30.5051 12.9459 30.0739C14.8836 29.7091 27.7659 28.7137 28.7361 29.2818C28.5744 29.9857 28.2916 30.874 27.9479 31.3045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26.3023 35.2241C24.3845 35.2241 18.2769 35.6497 14.3381 36.0015C14.07 34.8888 14.4207 33.9059 14.8744 33.4274C16.8534 33.0224 26.1164 32.3469 27.1066 32.9769C26.9421 33.7589 26.653 34.7445 26.3023 35.2241Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustandFaith);
export default __webpack_public_path__ + "static/media/TrustandFaith.c7bb41ef16447843f80b2e02d6bf3a5f.svg";
export { ForwardRef as ReactComponent };